import React, { useRef } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

/* Cinematic page banner matching the Home hero aesthetic */
export function PageHero({ image, tag, title, subtitle, breadcrumb, children }) {
  const ref = useRef(null);
  return (
    <section
      ref={ref}
      className="relative min-h-[48vh] flex items-end overflow-hidden pt-28 pb-12"
      data-testid="page-hero"
    >
      <motion.img
        src={image}
        alt={typeof title === "string" ? title : "VS Agro Infra Enterprises"}
        className="absolute inset-0 w-full h-full object-cover"
        initial={{ scale: 1.1 }}
        animate={{ scale: 1 }}
        transition={{ duration: 7, ease: "linear" }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-slate-950/92 via-slate-950/72 to-slate-950/40" />
      <div className="absolute inset-0 bg-slate-950/25" />
      <div className="absolute inset-0 blueprint-grid opacity-25 pointer-events-none" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        {breadcrumb && (
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="text-xs text-slate-400 mb-4"
          >
            <Link to="/" className="hover:text-orange-400 transition-colors">{breadcrumb.home}</Link>
            {" / "}
            <span className="text-orange-400">{breadcrumb.current}</span>
          </motion.div>
        )}
        {tag && (
          <motion.span
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.05 }}
            className="overline inline-block mb-4 border border-orange-500/30 px-3 py-1.5"
          >
            {tag}
          </motion.span>
        )}
        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="text-white"
          style={{
            fontFamily: "'Barlow Condensed', sans-serif",
            fontWeight: 900,
            fontSize: "clamp(2.25rem, 5vw, 4rem)",
            lineHeight: 0.98,
            textTransform: "uppercase",
            letterSpacing: "-0.03em",
          }}
        >
          {title}
        </motion.h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="text-slate-300 text-base md:text-lg mt-4 max-w-2xl leading-relaxed"
          >
            {subtitle}
          </motion.p>
        )}
        {children && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
            className="mt-6"
          >
            {children}
          </motion.div>
        )}
      </div>
    </section>
  );
}
